import e from "react";
import { c as n, t as s } from "./useKeyDown-88662051.mjs";
import { u as B } from "./app-51178863.mjs";
import { B as a } from "./useClickOutside-55c64a80.mjs";
import { I as p, a as g } from "./Image-be3826ec.mjs";
import { L as u } from "./Link-460da2fc.mjs";
import { B as m } from "./Button-eec2778c.mjs";
import "./ImageContext-57256dc1.mjs";
import "./LinkContext-0c83848a.mjs";
import "./Icon-e01b6482.mjs";
const E = "ctaBanner", y = "ctaBanner__image", h = "ctaBanner__content", x = "ctaBanner__button-container", _ = "ctaBanner__credits";
const f = "ctaBanner--has-image", b = "ctaBanner--employer", k = "ctaBanner--button-only";
const w = (i) => {
  const { headline: r, body: c, image: t, link: o, btnText: l } = i, d = B();
  return /* @__PURE__ */ e.createElement(
    a,
    {
      topPadding: a.Padding.LARGE,
      bottomPadding: a.Padding.LARGE,
      className: n(
        E,
        d && b,
        !!t && f,
        !r && !c && k
      ),
      "data-testid": "cta-banner-block"
    },
    t && /* @__PURE__ */ e.createElement(
      p,
      {
        credits: t.credits,
        src: t.src,
        width: t.width,
        height: t.height,
        altText: t.altText,
        imageLoader: t.imageLoader,
        className: y,
        styling: g.PREVIEW_CARD,
        "data-testid": "cta-banner-image"
      }
    ),
    /* @__PURE__ */ e.createElement(a.Content, { flex: !0, className: h }, !!r && /* @__PURE__ */ e.createElement("h2", { className: n(s.headingSection) }, r), !!c && /* @__PURE__ */ e.createElement("p", { className: n(s.textsLeadText) }, c), /* @__PURE__ */ e.createElement("div", { className: x }, /* @__PURE__ */ e.createElement(
      u,
      {
        className: m.PrimaryFocusStyleInLink,
        href: o.href,
        target: o.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        itemProp: "url"
      },
      /* @__PURE__ */ e.createElement(
        m.Primary,
        {
          text: l || o.title,
          asDiv: !0
        }
      )
    ))),
    t && /* @__PURE__ */ e.createElement(a.Content, { flex: !0, className: _ }, /* @__PURE__ */ e.createElement("div", { className: n(s.buttonTextPrimary) }, t.credits))
  );
};
export {
  w as CTABanner
};
//# sourceMappingURL=CTABanner.js.map
